import { makeStyles } from '@mui/styles'

const ButtonStyles = makeStyles((theme) => ({
  wideButton: {
    marginInline: '8px',
    borderRadius: '2rem',
    backgroundColor: theme.palette.grey[50],
    boxShadow: 'none',
    color: '#77838F',
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  buttonCustom: {
    backgroundColor: theme.palette.grey[50],
    border: '1px solid #77838F',
    borderRadius: '25px',
    padding: '5px 20px',
    color: '#333E48',
  },
  button_primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  button_error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.error.main,
    },
  },
  button_white: {
    border: `1px solid ${theme.palette.grey[500]}`,
    backgroundColor: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  button_grey: {
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.grey[500],
    },
  },
  button_orange: {
    backgroundColor: '#FF8C00',
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: '#FF8C00',
    },
  },
  button_yellow: {
    backgroundColor: theme.palette.yellow.main,
    color: theme.palette.grey[50],
    '&:hover': {
      backgroundColor: theme.palette.yellow.main,
    },
  },
  button_success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.dark.main,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
  },
}))

export default ButtonStyles
